import styled from "styled-components";
import { theme } from "../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import { h5Style } from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Type";
import { focusStyle } from "../../../../../../../common-deprecated/styles/v2/lexus/utilities/Focus";

const trackHeight = 4;
export const buttonSize = 24;

// Some explanation on the width/margins here:
// The ButtonSlider component uses the HTML width of the Slider div for calculations and positioning.
// As the calculations are done based on the "center" of a handle we need the Slider div to match the actual scrollable area.
// This is why we have the buttonSize / 2 left/right margin as that is "unreachable" area for the center of the buttons.
// However, visually it is a lot nicer if the slider background stretches to the full width without the margins, that is why we updated the ::after to add that "unreachable" area
const Slider = styled.div`
    position: relative;
    height: ${trackHeight}px;
    margin: 20px ${buttonSize / 2}px 25px;

    &::after {
        position: absolute;
        top: 0;
        left: -${buttonSize / 2}px;
        width: calc(100% + ${buttonSize}px);
        height: ${trackHeight}px;
        content: "";
        background-color: ${theme.colors.titanium};
        border-radius: 2px;
    }

    html[dir="rtl"] & {
        &::after {
            left: 0;
            right: -${buttonSize / 2}px;
        }
    }
`;

export const Value = styled.div`
    position: relative;
    text-align: center;
    user-select: none;
    ${h5Style};
`;

export const Handle = styled.button.attrs<{ left: number }>(({ left }) => ({
    style: {
        left: `${left - buttonSize / 2}px`,
    },
}))<{ left: number }>`
    position: absolute;
    top: -${buttonSize / 2 - 1}px;
    width: ${buttonSize}px;
    height: ${buttonSize}px;
    background-color: ${theme.colors.brushedSteel};
    border: 4px solid ${theme.colors.white};
    border-radius: 50%;
    z-index: 10;
    ${focusStyle};
`;

export const Track = styled.div.attrs<{ left: string; width: string }>(({ left, width }) => ({
    style: { left, width },
}))<{ left: string; width: string }>`
    position: absolute;
    top: 0;
    height: ${trackHeight}px;
    background: ${theme.colors.white};
    border: none;
    border-radius: 2px;
    z-index: 1;
`;

export default Slider;
